module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.curInput.key,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表单选择",
      "prop": "select_status"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.select_status),
      expression: "curInput.key.select_status"
    }],
    domProps: {
      "value": (_vm.curInput.key.select_status)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.select_status = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("本表")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("其他表单")])])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.key.select_status == 1),
      expression: "curInput.key.select_status == 1"
    }],
    attrs: {
      "label": "所选表单",
      "prop": "form_model"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.form_model),
      expression: "curInput.key.form_model"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请选择表单"
    },
    domProps: {
      "value": (_vm.curInput.key.form_model)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.form_model = $event
      }
    }
  }, _vm._l((_vm.formList), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选项标题配置",
      "prop": "title_config"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.key.title_config),
      expression: "curInput.key.title_config",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    attrs: {
      "placeholder": "请选择内容显示名称"
    },
    domProps: {
      "value": (_vm.curInput.key.title_config)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.title_config = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("填写规范遵循PHP语法,如：$姓名字段名.\"(\".$手机字段名.\")\".如果直接用某字段名，则填$字段名即可")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选项标题配置参考值"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title_reference),
      expression: "title_reference"
    }],
    staticClass: "w-300",
    attrs: {
      "multiple": "",
      "placeholder": "对选项标题配置参数值"
    },
    domProps: {
      "value": (_vm.title_reference)
    },
    on: {
      "input": function($event) {
        _vm.title_reference = $event
      }
    }
  }, _vm._l((_vm.fieldList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.name
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否级联方式选择",
      "prop": "is_link"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.is_link),
      expression: "curInput.key.is_link"
    }],
    domProps: {
      "value": (_vm.curInput.key.is_link)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.is_link = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否可选无",
      "prop": "has_null"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.has_null),
      expression: "curInput.key.has_null"
    }],
    domProps: {
      "value": (_vm.curInput.key.has_null)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.has_null = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curInput.key.is_link == 1),
      expression: "curInput.key.is_link == 1"
    }],
    attrs: {
      "label": "级联关联字段选择",
      "prop": "link_pid"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.link_pid),
      expression: "curInput.key.link_pid"
    }],
    attrs: {
      "placeholder": "级联关联字段选择"
    },
    domProps: {
      "value": (_vm.curInput.key.link_pid)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.link_pid = $event
      }
    }
  }, _vm._l((_vm.fieldList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.title + '(' + item.name + ')',
        "value": item.name
      }
    })
  }))]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "筛选条件",
      "prop": "filter"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.curInput.key.filter),
      expression: "curInput.key.filter",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-300",
    domProps: {
      "value": (_vm.curInput.key.filter)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.filter = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-tips"
  }, [_vm._v("支持等于==，不等于<>，大于>，小于<逻辑判断")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否有搜索功能",
      "prop": "has_search"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.has_search),
      expression: "curInput.key.has_search"
    }],
    domProps: {
      "value": (_vm.curInput.key.has_search)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.has_search = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "类型",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curInput.key.type),
      expression: "curInput.key.type"
    }],
    domProps: {
      "value": (_vm.curInput.key.type)
    },
    on: {
      "input": function($event) {
        _vm.curInput.key.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("下拉选择")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("模糊匹配")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3d61194b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/configComponents/foreignkeyConfig.vue
// module id = 1831
// module chunks = 2